<div class="container py-14 px-4">
  <h1 class="head-title">
    <T
      str="Gas prices"
      key="customerPortal.customer-portal.gas-prices.title"
      tags="customer-portal, 3.43"
    ></T>
  </h1>

  <form
    [formGroup]="filterForm"
    (ngSubmit)="onSubmit()"
    class="flex flex-col gap-4 px-2 mt-8"
    >
    <div class="flex flex-col md:flex-row md:items-center gap-0 md:gap-4">
      <mat-form-field subscriptSizing="dynamic" class="w-full md:flex-1 md:max-w-[380px]">
        <mat-label>
          <T
            str="Location"
            key="customerPortal.customer-portal.gas-prices.location"
            tags="customer-portal, 3.43"
          ></T>
        </mat-label>
        <input
          matInput
          type="text"
          autocomplete="off"
          title="Location"
          ef-feature-id="gas-prices.search.location-input"
          [formControl]="locationControl"
          [matAutocomplete]="locationAuto"
          />
        @if (locatingMe()) {
          <mat-spinner matSuffix diameter="20"></mat-spinner>
        }
        @if (!locatingMe()) {
          <div matSuffix class="flex items-center gap-1">
            @if (locationControl.value) {
              <span
                class="cursor-pointer inline-flex"
                matTooltip="{{ fuelPricesService.getClearLocationTranslation() }}"
                (click)="clearLocation()"
                >
                <mat-icon svgIcon="close" class="pointer-events-none text-mat-ef-revolution-grey-two-500"></mat-icon>
              </span>
            }
            <span
              class="cursor-pointer inline-flex"
              matTooltip="{{ fuelPricesService.getUseMyLocationTranslation() }}"
              ef-feature-id="gas-prices.search.location-button"
              (click)="useMyLocation()"
              >
              <mat-icon svgIcon="my_location" class="pointer-events-none text-mat-ef-revolution-primary-500"></mat-icon>
            </span>
          </div>
        }
        <mat-autocomplete
          #locationAuto="matAutocomplete"
          [displayWith]="fuelPricesService.displayPrediction"
          (optionSelected)="selectPrediction($event.option.value)"
          >
          @for (prediction of predictions(); track prediction.placeId) {
            <mat-option [value]="prediction">{{ prediction.description }}</mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>

      <mat-form-field subscriptSizing="dynamic" class="inline-block md:hidden w-full">
        <mat-label>
          <T
            str="Fuel type"
            key="customerPortal.customer-portal.gas-prices.fuel-type"
            tags="customer-portal, 3.43"
          ></T>
        </mat-label>
        <select
          required
          matNativeControl
          formControlName="fuelType"
          title="Fuel type"
          ef-feature-id="gas-prices.search.fuel-type-select"
        >
          @for (fuelType of fuelTypes; track fuelType) {
            <option [value]="fuelType">{{ fuelPricesService.getFuelTypeLabel(fuelType) }}</option>
          }
        </select>
      </mat-form-field>

      <mat-form-field subscriptSizing="dynamic" class="hidden md:inline-block md:w-1/4">
        <mat-label>
          <T
            str="Fuel type"
            key="customerPortal.customer-portal.gas-prices.fuel-type"
            tags="customer-portal, 3.43"
          ></T>
        </mat-label>
        <mat-select formControlName="fuelType" ef-feature-id="gas-prices.search.fuel-type-select-desktop">
          @for (fuelType of fuelTypes; track fuelType) {
            <mat-option [value]="fuelType">{{ fuelPricesService.getFuelTypeLabel(fuelType) }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field subscriptSizing="dynamic" class="inline-block md:hidden w-full">
        <mat-label>
          <T
            str="Radius"
            key="customerPortal.customer-portal.gas-prices.radius"
            tags="customer-portal, 3.43"
          ></T>
        </mat-label>
        <select
          required
          matNativeControl
          formControlName="radius"
          title="Radius"
        >
          @for (radius of radiusOptions; track radius) {
            <option [value]="radius">{{ radius }} km</option>
          }
        </select>
      </mat-form-field>

      <mat-form-field subscriptSizing="dynamic" class="hidden md:inline-block md:w-[130px]">
        <mat-label>
          <T
            str="Radius"
            key="customerPortal.customer-portal.gas-prices.radius"
            tags="customer-portal, 3.43"
          ></T>
        </mat-label>
        <mat-select formControlName="radius">
          @for (radius of radiusOptions; track radius) {
            <mat-option [value]="radius">{{ radius }} km</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field subscriptSizing="dynamic" class="inline-block md:hidden w-full">
        <mat-label>
          <T
            str="Sort by"
            key="customerPortal.customer-portal.gas-prices.sort"
            tags="customer-portal, 3.43"
          ></T>
        </mat-label>
        <select
          matNativeControl
          [formControl]="sortControl"
          title="Sort by"
          ef-feature-id="gas-prices.search.sort-select-mobile"
        >
          <option value="price">{{ 'Price' | translate:{ _key: 'customerPortal.customer-portal.gas-prices.sort.price', _tags: 'customer-portal, 3.43' } }}</option>
          @if (canSortByDistance()) {
            <option value="distance">{{ 'Distance' | translate:{ _key: 'customerPortal.customer-portal.gas-prices.sort.distance', _tags: 'customer-portal, 3.43' } }}</option>
          }
        </select>
      </mat-form-field>

      <mat-form-field subscriptSizing="dynamic" class="hidden md:inline-block md:w-[130px]">
        <mat-label>
          <T
            str="Sort by"
            key="customerPortal.customer-portal.gas-prices.sort"
            tags="customer-portal, 3.43"
          ></T>
        </mat-label>
        <mat-select [formControl]="sortControl" ef-feature-id="gas-prices.results.sort-select">
          <mat-option value="price" ef-feature-id="gas-prices.results.sort-option.price">
            <T
              str="Price"
              key="customerPortal.customer-portal.gas-prices.sort.price"
              tags="customer-portal, 3.43"
            ></T>
          </mat-option>
          @if (canSortByDistance()) {
            <mat-option value="distance" ef-feature-id="gas-prices.results.sort-option.distance">
              <T
                str="Distance"
                key="customerPortal.customer-portal.gas-prices.sort.distance"
                tags="customer-portal, 3.43"
              ></T>
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <button
        mat-flat-button
        color="primary"
        type="submit"
        title="Search"
        ef-feature-id="gas-prices.search.submit"
        [disabled]="!canSearch()"
        class="w-full md:w-auto shrink-0 md:h-14"
        >
        <T
          str="Search"
          key="customerPortal.customer-portal.gas-prices.search"
          tags="customer-portal, 3.43"
        ></T>
      </button>
    </div>

    @if (locationMissing()) {
      <div class="text-mat-ef-red-secondary-500 text-sm">
        <T
          str="Please select a location or add an address to your profile"
          key="customerPortal.customer-portal.gas-prices.location-required"
          tags="customer-portal, 3.43"
        ></T>
      </div>
    }

    @if (locationError()) {
      <div class="text-mat-ef-red-secondary-500 text-sm">
        <T
          str="Couldn't get your location. Please allow location access or search manually."
          key="customerPortal.customer-portal.gas-prices.location-error"
          tags="customer-portal, 3.43"
        ></T>
      </div>
    }
  </form>

  <div class="min-h-[280px]">
    @if (!loading() && !error() && !searched()) {
      <div class="mt-4 text-sm text-mat-ef-revolution-grey-two-500">
        <T
          str="Enter location name or ZIP to search for latest fuel prices."
          key="customerPortal.customer-portal.gas-prices.search-placeholder"
          tags="customer-portal, 3.43"
        ></T>
      </div>
    }

    @if (loading()) {
      <div class="mt-4">
        <ngx-skeleton-loader appearance="line" animation="progress" [count]="3"></ngx-skeleton-loader>
      </div>
    }

    @if (!loading() && error()) {
      <div class="mt-4 text-mat-ef-red-secondary-500 text-sm">
        <T
          str="Something went wrong while loading fuel prices. Please try again."
          key="customerPortal.customer-portal.gas-prices.error"
          tags="customer-portal, 3.43"
        ></T>
      </div>
    }

    @if (!loading() && !error() && searched() && fuelPrices()?.length === 0) {
      <div class="mt-4 text-sm">
        <T
          str="No fuel stations found for the selected filters."
          key="customerPortal.customer-portal.gas-prices.empty"
          tags="customer-portal, 3.43"
        ></T>
      </div>
    }

    @if (!loading() && fuelPrices()?.[0]) {
      <div class="mt-6">
      <div
        class="hidden md:grid gap-4 px-2 pb-2 text-xs font-semibold uppercase text-mat-ef-revolution-grey-two-500 border-b border-mat-ef-revolution-supergrey-500"
        [ngClass]="canSortByDistance() ? 'md:grid-cols-[110px_2fr_2fr_90px_minmax(140px,1fr)]' : 'md:grid-cols-[110px_2fr_2fr_minmax(140px,1fr)]'"
        >
        <div>
          <T
            str="Price"
            key="customerPortal.customer-portal.gas-prices.column.price"
            tags="customer-portal, 3.43"
          ></T>
        </div>
        <div>
          <T
            str="Station"
            key="customerPortal.customer-portal.gas-prices.column.station"
            tags="customer-portal, 3.43"
          ></T>
        </div>
        <div>
          <T
            str="Address"
            key="customerPortal.customer-portal.gas-prices.column.address"
            tags="customer-portal, 3.43"
          ></T>
        </div>
        @if (canSortByDistance()) {
          <div>
            <T
              str="Distance"
              key="customerPortal.customer-portal.gas-prices.column.distance"
              tags="customer-portal, 3.43"
            ></T>
          </div>
        }
        <div>
          <T
            str="Updated"
            key="customerPortal.customer-portal.gas-prices.column.updated"
            tags="customer-portal, 3.43"
          ></T>
        </div>
      </div>

      @for (price of fuelPrices(); track price; let last = $last) {
        <div
          ef-feature-id="gas-prices.results.price-item"
          class="grid grid-cols-1 gap-1 md:gap-4 md:items-center px-2 py-3 rounded w-full text-left"
          [ngClass]="canSortByDistance() ? 'md:grid-cols-[110px_2fr_2fr_90px_minmax(140px,1fr)]' : 'md:grid-cols-[110px_2fr_2fr_minmax(140px,1fr)]'"
          >
          @let priceParts = fuelPricesService.formatPrice(price.price);
          <div class="text-lg font-semibold leading-none text-mat-ef-revolution-primary-500">
            {{ priceParts.main }}<sup class="align-super text-[0.6em]">{{ priceParts.last }}</sup>&nbsp;{{ priceParts.symbol }}
          </div>
          <div class="flex gap-2 items-center">
            <div
              matTooltip="{{ fuelPricesService.getOpenNowTranslation(price) }}"
              [ngClass]="fuelPricesService.styleBlock(price)"
              class="rounded-xl shrink-0"
            ></div>
            <span class="text-base font-medium leading-5 break-words text-mat-ef-revolution-primary-500">
              {{ price.name }}
            </span>
          </div>
          <div class="flex items-start gap-2 text-sm break-words text-mat-ef-revolution-primary-500">
            <button
              type="button"
              (click)="openMap(price)"
              title="Open in Google Maps"
              aria-label="Open in Google Maps"
              class="inline-flex items-center justify-center mt-[1px]"
              >
                <mat-icon svgIcon="directions" class="text-mat-ef-revolution-primary-500"></mat-icon>
            </button>
            <span>{{ price.street }} {{ price.zip }} {{ price.city }}</span>
          </div>
          @if (canSortByDistance()) {
            <div
              ef-feature-id="gas-prices.results.distance"
              class="text-sm text-mat-ef-revolution-primary-500"
              >
              {{ fuelPricesService.getDistance(price) }}
            </div>
          }
          <div class="flex flex-col text-xs text-mat-ef-revolution-grey-two-500">
            @if (price.reportedAt != null) {
              <span>{{ fuelPricesService.getReportedAgo(price) }}</span>
            }
            @if (price.openNow !== true && price.openNext != null) {
              <span class="font-bold text-mat-ef-revolution-primary-500">
                <T
                  str="Opens"
                  key="customerPortal.customer-portal.gas-prices.opens"
                  tags="customer-portal, 3.43"
                ></T>
                {{ fuelPricesService.getOpensNext(price) }}
              </span>
            }
          </div>
        </div>
        @if (!last) {
          <mat-divider class="mx-1"></mat-divider>
        }
      }
    </div>
    }
  </div>
</div>
